import { render, staticRenderFns } from "./ContentBlockImage.vue?vue&type=template&id=73db4684"
import script from "./ContentBlockImage.vue?vue&type=script&lang=ts"
export * from "./ContentBlockImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports